import tr from 'ele-admin/packages/lang/tr-TR';

export default {
  ...tr,
  el: {
    ...tr.el,
    datepicker: {
      ...tr.el.datepicker,
      weeks: {
        sun: 'Pazar', // 星期日
        mon: 'Paz', // 星期一
        tue: 'Salı', // 星期二
        wed: 'Çar', // 星期三
        thu: 'Per', // 星期四
        fri: 'Cuma', // 星期五
        sat: 'Cum' // 星期六
      }
    }
  }
};
